import React from "react";
import { responsiveImage } from "../lib/responsiveImage";

/**
 * Drop-in <img> replacement that produces an optimized responsive variant.
 *
 * Props:
 *  - src (string, required)     — raw URL (Cloudinary, Unsplash, or passthrough)
 *  - alt (string, required)     — descriptive alt-text
 *  - aspect (e.g. "16/9", "9/16", "4/3") — if set, applies smart-crop fill (g_auto)
 *  - widths ([400,800,1200,1920]) — srcSet widths
 *  - sizes (string)             — sizes attribute, sensible default if omitted
 *  - fit ("limit"|"fill")       — crop mode (only used if aspect is NOT set)
 *  - eager (bool)               — set true for above-the-fold hero (loading="eager", fetchPriority="high")
 *  - className                  — Tailwind / CSS classes
 *  - All other props are forwarded to the underlying <img>.
 */
export function SmartImage({
  src,
  alt = "",
  aspect,
  widths,
  sizes,
  fit,
  eager = false,
  className = "",
  ...rest
}) {
  if (!src) return null;
  const r = responsiveImage(src, { aspect, widths, sizes, fit });
  if (!r) return null;
  return (
    <img
      src={r.src}
      srcSet={r.srcSet}
      sizes={r.sizes}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={eager ? "high" : "auto"}
      className={className}
      {...rest}
    />
  );
}

export default SmartImage;
